<div id="step-serial-number-search" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    <section class="row">
      <div class="field-wr flex flex-col col-12">
        <div class="row">
          <div class="flex flex-col col-12 mb-4">
            <h2 data-testid="activation-sumary-title" class="border-b pb-3">{{ 'WARRANTY_ACTIVATION.SUMMARY' | translate }}</h2>
          </div>
          <div class="field-wr flex flex-col items-center col-12 col-md-12">
            @if (activatedSuccessfully) {
              <svg viewBox="0 0 20 20" aria-hidden="true" width="68" height="68" class="mt-5 mb-3">
                <path class="cls-1" d="M10,.9c5,0,9.1,4.1,9.1,9.1s-4.1,9.1-9.1,9.1S.9,15,.9,10,5,.9,10,.9M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0h0Z"/>
                <path class="cls-1" d="M9.3,13.5c-.1,0-.2,0-.3,0l-2.6-2.1c-.2-.2-.2-.4,0-.6.2-.2.4-.2.6,0l2.3,1.8,4-5.1c.1-.2.4-.2.6,0,.2.1.2.4,0,.6l-4.3,5.5c0,0-.2.2-.3.2,0,0,0,0,0,0Z"/>
              </svg>
              <p>{{ 'WARRANTY_ACTIVATION.WARRANTY_ACTIVATION_FEEDBACK_SUCCESS' | translate }}</p>
              <div class="mt-6">
                <button data-testid="activation-summary-activate-another-btn" class="btn outline-btn" (click)="onBackToWarranties()">{{
                'WARRANTY_ACTIVATION.BTN_ACTIVATE_ANOTHER_WARRANTY' | translate }}</button>
              </div>
            } @else {
              <svg viewBox="0 0 20 20" aria-hidden="true" width="68" height="68" class="mt-5 mb-3">
                <path class="cls-1" d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0ZM10,19.1C5,19.1.9,15,.9,10S5,.9,10,.9s9.1,4.1,9.1,9.1-4.1,9.1-9.1,9.1Z"/>
                <path class="cls-1" d="M13.1,6.9c-.2-.2-.5-.2-.6,0l-2.4,2.4-2.4-2.4c-.2-.2-.5-.2-.6,0-.2.2-.2.5,0,.6l2.4,2.4-2.4,2.4c-.2.2-.2.5,0,.6,0,0,.2.1.3.1s.2,0,.3-.1l2.4-2.4,2.4,2.4c0,0,.2.1.3.1s.2,0,.3-.1c.2-.2.2-.5,0-.6l-2.4-2.4,2.4-2.4c.2-.2.2-.5,0-.6h0Z"/>
              </svg>
              <p>{{ 'WARRANTY_ACTIVATION.WARRANTY_ACTIVATION_FEEDBACK_FAILURE' | translate }}</p>
            }
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
